module.exports = __webpack_public_path__ + "img/s4.b05fcf9.png";